export interface LoadCacheStatus {
  finished: boolean;
  errors: boolean;
  planServicesCurrent: number;
  planServicesTotal: number;
  optionPlanServicesCurrent: number;
  optionPlanServicesTotal: number;
  selectedPlansCurrent: number;
  selectedPlansTotal: number;
}

export const initialCacheStatusValue: LoadCacheStatus = {
  finished: false,
  errors: false,
  planServicesCurrent: 0,
  planServicesTotal: 100,
  optionPlanServicesCurrent: 0,
  optionPlanServicesTotal: 100,
  selectedPlansCurrent: 0,
  selectedPlansTotal: 100,
};

function calculatePercentage(completed: number, total: number): number {
  return total > 0 ? Math.round((completed / total) * 100) : 0;
}

export function getColorForStatus(status: LoadCacheStatus): string {
  if (isLoadingPlanServices(status)) {
    return 'progress progress-primary w-full';
  }
  if (isLoadingOptionPlanServices(status)) {
    return 'progress progress-secondary w-full';
  }
  if (isLoadingSelectedPlans(status)) {
    return 'progress progress-warning w-full';
  }
  return 'progress progress-error w-full';
}

export function getLoadingTextForStatus(status: LoadCacheStatus): string {
  if (isLoadingPlanServices(status)) {
    return 'Loading plan services...';
  }
  if (isLoadingOptionPlanServices(status)) {
    return 'Loading option plan services...';
  }
  if (isLoadingSelectedPlans(status)) {
    return 'Loading selected plans...';
  }
  if (status.finished && !status.errors) {
    return 'Cache loading completed successfully';
  }
  if (status.errors) {
    return 'Cache loading encountered an error. Please restart the application.';
  }
  return 'Cache loading in progress. Please wait...';
}

function isLoadingPlanServices(status: LoadCacheStatus): boolean {
  return (
    !status.finished &&
    !status.errors &&
    status.planServicesCurrent > 0 &&
    status.planServicesCurrent < status.planServicesTotal
  );
}

function isLoadingOptionPlanServices(status: LoadCacheStatus): boolean {
  return (
    !status.finished &&
    !status.errors &&
    status.optionPlanServicesCurrent > 0 &&
    status.optionPlanServicesCurrent < status.optionPlanServicesTotal
  );
}

function isLoadingSelectedPlans(status: LoadCacheStatus): boolean {
  return (
    !status.finished &&
    !status.errors &&
    status.selectedPlansCurrent > 0 &&
    status.selectedPlansCurrent < status.selectedPlansTotal
  );
}

export function getLoadingCacheProgressPercentage(
  status: LoadCacheStatus,
): number {
  if (status.finished) {
    return 100;
  }
  if (status.errors) {
    return 0;
  }
  if (isLoadingPlanServices(status)) {
    return calculatePercentage(
      status.planServicesCurrent,
      status.planServicesTotal,
    );
  }
  if (isLoadingOptionPlanServices(status)) {
    return calculatePercentage(
      status.optionPlanServicesCurrent,
      status.optionPlanServicesTotal,
    );
  }
  if (isLoadingSelectedPlans(status)) {
    return calculatePercentage(
      status.selectedPlansCurrent,
      status.selectedPlansTotal,
    );
  } else return 0;
}
